import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import qs from 'qs';

export const query = gql`
  query GetTracksAdmin($input: GetTracksAdminInput!) {
    getTracksAdmin(input: $input) {
      count
      counts {
        live
        active
        inactive
      }
      results {
        id
        name
        short_name
        size
        logo
        cityAndState
        type {
          id
          key
          value
        }
        timezone
        active
        eventsCount
      }
    }
  }
`;
export default graphql(query, {
  options: (props) => {
    const search = qs.parse(props.location.search, { ignoreQueryPrefix: true });

    return {
      variables: { input: search },
    };
  },
});
